<template>
  <div>
    <a href="https://www.iucn.org/"> <span class="popup-close">+</span> </a>
    <div class="left-panel">
      <div class="left-inner">
        <div class="language-switch-container">
          <locale-switch></locale-switch>
        </div>
        <!-- <div class="lp-signup">
          <p>{{$t("auth.register__top_line")}}</p>
          <router-link to="/auth/login" class="btn btn-primary btn-simple">{{$t("auth.btn_login")}}</router-link>
        </div> -->

        <h1>{{ $t('auth.forgot__title') }}</h1>
        <h3>{{ $t('auth.forgot__subtitle') }}</h3>

        <form @submit.prevent="requestResetPassword" v-if="!submitted">
          <div>
          <span class="lp-form-input">
            <input type="text"
                   v-validate="'required|email'"
                   name="email"
                   :error="getError('email')"
                   v-model="model.email"
                   id="email"
                   :class="{ 'has-danger': getError('email') }"
            />
            <label for="email">{{ $t('auth.input_email') }}</label>
            <span v-if="getError('email')" class="has-error">{{ getError('email') }}</span>
            </span>
          </div>

          <p class="mt-3">
            {{ $t('auth.forgot__instructions') }}
          </p>

          <div slot="footer">
            <button class="btn btn-lg btn-primary submit-button" :class="{'disabled': loading}" :disabled="loading" type="submit">{{ $t('auth.btn_send') }}</button>
          </div>
        </form>

        <p v-if="submitted && success">
          {{ $t('auth.forgot__sent_success') }}
        </p>

        <p v-if="submitted && !success">
          {{ $t('auth.forgot__sent_failed') }}
        </p>

      </div>
    </div>
    <div class="right-panel">
      <canvas class="strength-indicator" width="628" height="679"></canvas>
    </div>
  </div>
</template>
<script>
  import LocaleSwitch from "@/components/LocaleSwitch";
  import {AuthService} from "@/services";

  export default {
    data() {
      return {
        loading: false,
        submitted: false,
        success: false,
        model: {
          email: ''
        }
      };
    },
    components: {
      LocaleSwitch
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      async requestResetPassword() {
        let isValidForm = await this.$validator.validateAll();
        if (isValidForm) {
          this.loading = true;

          await AuthService.requestResetPassword({email: this.model.email}).then((response) => {
            this.success = true;
          }).catch(function (error) {

          })

          this.submitted = true;
          this.loading = false;
        }
      }
    }
  };
</script>
<style lang="scss">
  .full-page .content .lp-form-input input {
    padding-left: 15.671875vh;
  }
</style>
